import { findOptions, getDivergenceOrEqual } from "../../../helpers/StringHelper";

export const mapLirs = (data, options, max = 1) => {
  const {
    categoryOptions = [],
    countryOptions = [],
    provinceOptions = [],
    territoryOptions = []
  } = options || {};
  return data.map(lir => {
    const location = lir && lir.location && lir.location.administrativeLevel1 ? lir.location : {};
    const author = lir.author ? (lir.author.name ? lir.author.name : `${lir.author.firstName} ${lir.author.lastName}`) : '';
    const childrens = (lir.children || []);
    const config = {
      dbId: lir.id,
      pmeProject: lir.pmeProject,
      author,
      id: lir ? lir.datastakeId : '',
      type: lir ? findOptions(lir.category, categoryOptions) : '',
      name: lir ? (lir.name && lir.name !== '' ? lir.name : lir.fullName) : '',
      country: lir && lir.country ? findOptions(lir.country, countryOptions) : '',
      province: location.administrativeLevel1 ? findOptions(location.administrativeLevel1, provinceOptions) : '',
      territory: location.administrativeLevel2 ? findOptions(location.administrativeLevel2, territoryOptions) : '',
      city: location.town ? location.town : '',
      version: lir.version,
      authorId: lir.authorId ? lir.authorId : undefined,
      updatedAt: lir.updatedAt,
      publishedAt: lir.publishedAt,
    };
    if (childrens.length > max) {
      Object.assign(config, {
        children: mapLirs(childrens, options),
      });
      config.sourcesLen = config.children.length;
    }
    return getDivergenceOrEqual(config, ['province', 'territory']);
  })
}

export const getLirFilterOptions = (options) => {
  const {
    categoryOptions = [],
    countryOptions = [],
    subCategoryOptions,
    administrativeLevel1,
    administrativeLevel2,
  } = options || {};

  return {
    category: categoryOptions,
    country: countryOptions,
    subCategory: subCategoryOptions,
    administrativeLevel1,
    administrativeLevel2,
  }
}

export const filtersConfig = {
  name: '',
  datastakeId: '',
};

export const selectFiltersConfig = {
  country: {
    type: 'select',
    label: 'Country',
    placeholder: (t) => `${t('Filter by')} ${t('Country').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  administrativeLevel1: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel1 } = options;

      if (administrativeLevel1) {
        if (options.country) {
          const _item = administrativeLevel1[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    placeholder: (t) => `${t('Filter by')} ${t('Province').toLowerCase()}`,
    filters: (data) => ({
      country: data.country,
      level: 'level_1',
    }),
    show: (data) => !!!data.country,
    disabled: (data) => !!!data.country,
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },
  administrativeLevel2: {
    type: 'ajaxSelect',
    label: ({ t = (s) => s, options = {}, filters = {}, language = 'en' }) => {
      const { administrativeLevel2 } = options;

      if (administrativeLevel2) {
        if (options.country) {
          const _item = administrativeLevel2[filters.country];
          if (_item) {
            if (_item[language]) {
              return _item[language]
            }
          }
        }
      }

      return t('Province');
    },
    show: (data) => !(data.country && data.administrativeLevel1),
    placeholder: (t) => `${t('Filter by')} ${t('Territory').toLowerCase()}`,
    filters: (data) => ({
      country: data.country,
      level: 'level_2',
      administrativeLevel1: data.administrativeLevel1,
    }),
    disabled: (data) => !(data.country && data.administrativeLevel1),
    mapper: { label: "name", value: "id" },
    method: 'getOptions',
    entity: 'AdministrativeLevel',
    style: { flex: 1 },
    labelStyle: { flex: 1 },
  },
  category: {
    type: 'select',
    label: 'Category',
    placeholder: (t) => `${t('Filter by')} ${t('Category').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
  },
  subCategory: {
    type: 'select',
    label: 'Sub Category',
    placeholder: (t) => `${t('Filter by')} ${t('Sub Category').toLowerCase()}`,
    style: { flex: 1 },
    labelStyle: { flex: 1 },
    show: (data) => !!!data.category,
    getLabel: (option) => option.label,
    getValue: (option) => option.value,
    filterOptions: (val) => {
      if (val) {
        const { option, filters } = val
        if (filters && option) {
          const { filters: optionFilters } = option;
          if (Array.isArray(optionFilters) && optionFilters.length) {
            const { value, condition } = optionFilters[0];
            if (condition === 'includes') {
              return value.includes(filters.category);
            }
          }
        }
      }
      return true;
    },
  },
};

export const checkboxConfig = {
  name: 'Name',
  datastakeId: 'ID',
};
